import { isBefore, subMonths } from "date-fns";

import { FILTER } from "@/constants";
import { hasValidFilters } from "@/containers/Filters/utils";
import { useEpisodes } from "@/contexts/EpisodesContext";
import { useMentionCards } from "@/contexts/MentionCardsContext";
import useFilterParams from "@/hooks/useFilterParams";

import Empty from "./Empty";
import EmptyTimePeriod from "./EmptyTimePeriod";
import FilteredEmpty from "./FilteredEmpty";
import GenericError from "./GenericError";

const AllMessages: React.FC<{ v4?: boolean }> = ({ v4 = false }) => {
  const legacyEpisodesResult = useEpisodes();
  const mentionCardsResult = useMentionCards();

  const alert = v4 ? mentionCardsResult.alert : legacyEpisodesResult.alert;
  const errors = v4 ? mentionCardsResult.errors : legacyEpisodesResult.errors;
  const episodes = v4
    ? mentionCardsResult.mentionCards
    : legacyEpisodesResult.episodes;

  const [filters] = useFilterParams();

  // the start date is already set to start date of the alert
  const filterStartDateIsAlertStart =
    alert?.start_date === filters[FILTER.START_DATE];

  // the start date is either within the default range ( 3 months )
  const alertIsNewerThan3Months = alert?.start_date
    ? isBefore(subMonths(new Date(), 3), new Date(alert.start_date))
    : false;
  const unFiltered = hasValidFilters(filters) === false;
  const onlyOneFilterActive = Object.keys(filters).length === 1;

  const newUnfiltered = alertIsNewerThan3Months && unFiltered;
  const isHistoricallyEmpty =
    // there are no episodes
    episodes?.length === 0 &&
    (newUnfiltered ||
      (filterStartDateIsAlertStart &&
        // and the date is the only parameter
        onlyOneFilterActive));

  return errors?.length ? (
    <GenericError />
  ) : isHistoricallyEmpty ? (
    <Empty />
  ) : unFiltered ? (
    <EmptyTimePeriod v4={v4} />
  ) : (
    <FilteredEmpty v4={v4} />
  );
};

export default AllMessages;
